/** Local/Umbraco React XC2 preview slugs (canonical PageUrl is the same without `-new`). */
export const XC_NEW_SLUGS = new Set(["winbig-new", "1winbig-new", "2winbig-new", "3winbig-new"]);
